import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Document attachment SVG Icon
 */
export const DocumentAttachment: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 19 22"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M2 22H17C18.1046 22 19 21.1046 19 20V7.69578C19 7.16988 18.7929 6.66513 18.4234 6.29084L12.8016 0.59506C12.4258 0.214319 11.9132 0 11.3782 0H2C0.89543 0 0 0.89543 0 2V20C0 21.1046 0.895431 22 2 22Z"
      fill="white"
    />
    <path
      d="M19 6.875L12.2143 0V3.675C12.2143 5.44231 13.647 6.875 15.4143 6.875H19Z"
      fill="#E2E2E2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.76653 16.281C9.76653 16.5708 9.56375 16.7546 9.25683 16.7546C8.97732 16.7546 8.83483 16.6321 8.7307 16.32L8.08946 14.5203H5.05868L4.41745 16.32C4.31332 16.6321 4.17083 16.7546 3.88583 16.7546C3.57892 16.7546 3.39258 16.5763 3.39258 16.2866C3.39258 16.1919 3.40902 16.1027 3.45286 15.9801L5.85337 9.46653C5.97943 9.10993 6.21509 8.93719 6.57681 8.93719C6.94402 8.93719 7.17968 9.10993 7.31122 9.4721L9.70625 15.969C9.74461 16.0916 9.76653 16.1807 9.76653 16.281ZM5.32227 13.6605H7.82143L6.58829 10.1502H6.5554L5.32227 13.6605ZM14.9352 16.7497C15.2093 16.7497 15.3956 16.5659 15.3956 16.2594V11.2892C15.3956 10.9884 15.2093 10.7933 14.9352 10.7933C14.6722 10.7933 14.4858 10.9884 14.4858 11.2892V11.9969H14.4475C14.1351 11.2502 13.4281 10.8045 12.5676 10.8045C11.1536 10.8045 10.2109 11.9969 10.2109 13.7743C10.2109 15.5629 11.1536 16.7442 12.5676 16.7442C13.4555 16.7442 14.1351 16.3207 14.4475 15.5629H14.4858V16.2706C14.4858 16.5714 14.6722 16.7497 14.9352 16.7497ZM11.1855 13.7736C11.1855 15.0886 11.8158 15.9188 12.8078 15.9188C13.8108 15.9188 14.4575 15.0886 14.4575 13.7847C14.4575 12.4865 13.8053 11.6284 12.8078 11.6284C11.8158 11.6284 11.1855 12.4586 11.1855 13.7736Z"
      fill="#2B2B2B"
    />
  </AccessibleSVG>
)
